import { createTheme } from '@mantine/core';

export const theme = createTheme({
  /** Put your mantine theme override here */
  primaryColor: 'primary',
  primaryShade: 7,
  fontFamily: 'Open Sans, sans-serif',
  defaultRadius: 'md',
  colors: {
    primary: [
      '#faeffb',
      '#f0daf2',
      '#e2b2e6',
      '#d487db',
      '#c863d1',
      '#c14dcb',
      '#be41c8',
      '#7B2183',
      '#952d9e',
      '#82238b'
    ],
    secondary: [
      '#f8f3f9',
      '#e8e6e8',
      '#ceccce',
      '#b3afb3',
      '#9b979b',
      '#8d888d',
      '#878087',
      '#756d75',
      '#696169',
      '#5d525d'
    ],
    destructive: [
      '#ffebea',
      '#fdd5d4',
      '#f4aaa7',
      '#ed7b76',
      '#e7544d',
      '#e43b33',
      '#e32d25',
      '#ca2019',
      '#b51915',
      '#9e0d0f'
    ],
    grey: [
      '#f3f3f7',
      '#e4e4e6',
      '#c6c7ce',
      '#a7a8b6',
      '#8c8ea1',
      '#7b7d95',
      '#727590',
      '#60637e',
      '#555871',
      '#484b65'
    ]
  },
  shadows: {
    md: '0 4px 8px 0 rgba(0, 0, 0, 0.1)',
    xl: '0 8px 16px 0 rgba(0, 0, 0, 0.1)'
  },
  headings: {
    fontFamily: 'Open Sans, sans-serif',
    sizes: {
      h1: { fontSize: '2rem' },
      h2: { fontSize: '1.5rem' },
      h3: { fontSize: '1.25rem' },
      h4: { fontSize: '1.125rem' }
    }
  },
  components: {
    AppShell: {
      styles: {
        main: {
          background: '#F4F4F4'
        },
        navbar: {
          background: '#F4F4F4'
        }
      }
    },
    Text: {
      styles: {
        root: {
          color: '#645C64'
        }
      }
    },
    NavLink: {
      styles: {
        root: {
          fontSize: '0.875rem',
          fontWeight: '600',
          padding: '0.5rem 1rem',
          borderRadius: 8
        }
      }
    },
    Divider: {
      styles: {
        label: {
          color: '#645C64'
        },
        root: {
          borderColor: '#ccd1df'
        }
      }
    },
    Button: {
      styles: {
        root: {
          borderRadius: 8,
          maxHeight: 36
        },
        label: {
          overflow: 'unset'
        }
      }
    },
    TextInput: {
      styles: {
        input: {
          borderRadius: 8,
          lineHeight: '1.2em',
          height: 'auto'
        },
        label: {
          fontSize: '0.875rem',
          overflow: 'unset'
        }
      }
    },
    PasswordInput: {
      styles: {
        input: {
          minHeight: 50
        },
        innerInput: {
          padding: 16,
          borderRadius: 8,
          lineHeight: '1.2em',
          height: 'auto',
          overflow: 'unset',
          minHeight: 50
        },
        label: {
          fontSize: '0.875rem'
        }
      }
    }
  }
});
